import {
    LIMIT_BATCH_IS_PREMIUM,
    LIMIT_FEATURE_IS_PREMIUM,
    LIMIT_FEATURE_TOO_MANY_JOBS,
    LIMIT_GENERIC,
    LIMIT_GENERIC_CONVERSION_OPTION_IS_PREMIUM,
    LIMIT_GLOBAL_TOO_MANY_JOBS,
    LIMIT_INPUT_TOO_LARGE,
    LIMIT_JOB_TOO_LARGE,
    LIMIT_OCR_IS_PREMIUM,
    LIMIT_TOO_MANY_INPUTS,
    LIMIT_CREDITS_CONSUMED,
    LIMIT_UNKNOWN,
    LIMIT_GLOBAL_TOO_MANY_CONCURRENT_CONVERSIONS,
    LIMIT_CREDITS_CONSUMED_WAS_PREMIUM, LIMIT_JOB_CONVERSIONS_BLOCKED
} from '../../../limits/limits';
import { globalLogger } from '../../../../qaamgo/helper/global-logger';
import { UPLOAD_BOX_ERROR_TYPE } from '../const';
import { translate } from '../../../../qaamgo/helper/translate';
import {
    testIsEmptyArray,
    testIsNonEmptyString,
    testIsNotNull,
    testIsUndefined,
} from '../../../../lib/test-and-assert/test-base';
import { assertIsArray, assertObjectHasKey } from '../../../../lib/test-and-assert/assert-base';
import { LIMITS_ORIGIN_PAGE_LOAD } from '../../../store/modules/limits-store';
import { userManager } from '../../../user/user-manager';
import { paymentManager } from '../../../payment/payment-manager';
import { satGlobals } from '../../../../qaamgo/sat/helper/sat-globals';
import {parseSecondsToReadable} from "../../../../lib/timer/parse-time";

/**
 * @param {StoreEntryLimit[]} storeEntryLimits
 * @return {?DisplayLimitError}
 */
function getDisplayErrorDataFromStoreEntryLimits(storeEntryLimits) {
    assertIsArray(storeEntryLimits);

    const n = storeEntryLimits.length;

    // TODO:
    //   add priorization here when more than one limits are available. it does not always
    //   make sense to just take the last one.
    const storeEntryLimit = storeEntryLimits[n - 1];

    assertObjectHasKey(storeEntryLimit, 'origin');
    assertObjectHasKey(storeEntryLimit, 'limits');
    assertIsArray(storeEntryLimit.limits);

    let displayLimitData = getLimitDataFromStoreEntryLimit(storeEntryLimit);

    if (displayLimitData === null) {
        return null;
    }

    const errorData = getDisplayErrorDataFromLimitData(displayLimitData);

    errorData.origin = storeEntryLimit.origin;

    return errorData;
}

export { getDisplayErrorDataFromStoreEntryLimits };

/**
 * @param {StoreEntryLimit} storeEntryLimit
 * @return {?LimitData}
 */
function getLimitDataFromStoreEntryLimit(storeEntryLimit) {
    if (testIsEmptyArray(storeEntryLimit.limits)) {
        return null;
    }

    const origin = storeEntryLimit.origin;

    let selectedLimitData = null;

    // TODO: make a clever logic which selects the correct limit if there are more than one limit
    storeEntryLimit.limits.forEach((/** LimitData */ limitData) => {
        if (testIsNotNull(limitData.expiresAt) && limitData.expiresAt <= Date.now()) {
            return;
        }

        if (testIsNotNull(limitData.hit) && !limitData.hit) {
            return;
        }

        // TODO add logic to prioritize limits based on type?
        if (selectedLimitData !== null) {
            return;
        }

        // do not allow displaying conversion option limits directly on page load
        if (origin === LIMITS_ORIGIN_PAGE_LOAD && limitData.constraintType === 'conversion_option') {
            return;
        }

        if (limitData.constraintType === 'conversion_operation') {
            if (!limitData.hit) {
                return;
            }

            if (!testIsNonEmptyString(limitData.triggeredBy)) {
                return;
            }

            // if the current operation does not match the operation in the constraint,
            // we skip even if the limit is hit
            if (global.pageConfig?.operation !== limitData.triggeredBy) {
                return;
            }
        }

        selectedLimitData = limitData;
    });

    return selectedLimitData;
}

/**
 * @param {LimitData} limitData
 *
 * @return {DisplayLimitError}
 */
function getDisplayErrorDataFromLimitData(limitData) {
    // limit_unknown should not happen - pls send better limit info
    if (limitData.type === LIMIT_UNKNOWN) {
        globalLogger.log('upload box show error - unknown');

        limitData.type = LIMIT_GENERIC;
    }

    /** @type {?User} */
    const user = userManager.getCurrentUserFromStore();

    const freeItems = paymentManager.getFreeItems();

    let isFreeUser = false;
    let isPremiumUser = false;
    let isEducationalUser = false;


    if (user) {
        isPremiumUser = user.isPremium();
        isEducationalUser = user.isEducational();
        isFreeUser = user.isRegistered() && (!isPremiumUser || !isEducationalUser);
    }

    if (isPremiumUser === false && user.isWasPremium() === true) {
        limitData.type = LIMIT_CREDITS_CONSUMED_WAS_PREMIUM;
    }

    /**
     * @type {DisplayLimitError}
     */
    const errorObj = {
        name: limitData.type,
        data: limitData,
        type: UPLOAD_BOX_ERROR_TYPE.GENERIC,
        title: null,
        description: [],
        origin: null,
        canDismiss: true,
        showTryPremiumButton: true,
        showStartButton:true,
        showSignUpButton: false,
        showReferralButton: false,
    };

    switch (limitData.type) {
        case LIMIT_CREDITS_CONSUMED_WAS_PREMIUM:
            errorObj.title = translate('Not Enough Credits Left');
            errorObj.description.push(translate(
                'Your subscription ran out of Credits. Get a Credit add-on for instant renewal.'
            ));
            errorObj.canDismiss = true;
            
            break;
        case LIMIT_GENERIC:
            errorObj.title = translate('Upgrade your account');
            errorObj.description.push(translate(
                'For this action, you require a premium account. Upgrade to get full access to all our tools.'
            ));

            break;
        case LIMIT_CREDITS_CONSUMED:
            //TDOD Discuss whether to add feeature flag to this
            if (satGlobals.isCreditsEnabled()) {
                if (isPremiumUser || isEducationalUser) {
                    errorObj.type = UPLOAD_BOX_ERROR_TYPE.COUNTDOWN;
                    errorObj.title = translate('Not Enough Credits Left');
                    errorObj.description.push(translate(
                        'Your subscription ran out of Credits and will renew in %time%. Get a Credit add-on for instant renewal.'
                    ));
                    errorObj.canDismiss = false;
                } else if (isFreeUser) {
                    errorObj.type = UPLOAD_BOX_ERROR_TYPE.COUNTDOWN;
                    errorObj.canDismiss = false;
                    errorObj.showSignUpButton = false;
                    errorObj.showReferralButton = true;

                    errorObj.title = translate('Not Enough Credits Left');
                    errorObj.description = [
                        translate("But don't worry, here are your options:"),
                        translate('<strong>Upgrade to Premium</strong> – Unlock instant access and exclusive features.'),
                        translate('Or <strong>refer a friend</strong> - Earn Credits for each successful referral!'),
                        translate('Or <strong>Come back in %time%</strong> and get a fresh set of free credits!'),
                    ];
                } else {
                    errorObj.type = UPLOAD_BOX_ERROR_TYPE.COUNTDOWN;
                    errorObj.canDismiss = false;
                    errorObj.showSignUpButton = true;

                    errorObj.title = translate('Not Enough Credits Left');
                    errorObj.description = [
                        translate("But don't worry, here are your options:"),
                        translate('<strong>Upgrade to Premium</strong> – Unlock instant access and exclusive features.'),
                        translate(`Or <strong>Sign up now</strong> – Get ${freeItems?.welcome_credits} Welcome Credits to continue testing.`),
                        translate('Or <strong>Come back in %time%</strong> and get a fresh set of free credits!'),
                    ];
                }
            } else {
                if (isPremiumUser || isEducationalUser) {
                    errorObj.title = translate('Maximum number of tasks reached');
                    errorObj.description.push(translate(
                        'You have reached the maximum amount of tasks you can do. Come back in %time% to work on more tasks.'
                    ));
                    errorObj.showTryPremiumButton = false;
                } else {
                    errorObj.title = translate('Do you need to do more?');
                    errorObj.description.push(translate(
                        'Upgrade to a premium account or come back in %time% to work on more files.'
                    ));
                }
            }

            break;
        case LIMIT_TOO_MANY_INPUTS:
            if (isPremiumUser || isEducationalUser) {
                errorObj.title = translate('Maximum number of files reached');
                errorObj.description.push(translate('The maximum amount of processed files has been reached'));
                errorObj.showTryPremiumButton = false;
            } else {
                errorObj.title = translate('Upgrade and convert more files at once!');
                
                let description = translate(
                    'Processing more than %count% files in a single task is only available for our premium users.'
                );
                errorObj.description.push(description.replace('%count%', limitData.maxValue));
            }

            break;
        case LIMIT_BATCH_IS_PREMIUM:
            errorObj.title = translate('Upgrade to premium for batch processing');
            errorObj.description.push(translate(
                'Batch processing is only available for premium users. Upgrade to process multiple files.'
            ));

            break;
        case LIMIT_INPUT_TOO_LARGE:
            if (isPremiumUser || isEducationalUser) {
                errorObj.title = translate('Filesize limit reached');
                errorObj.description.push(translate('The maximum file size amount has been reached.'));
                errorObj.showTryPremiumButton = false;
            } else {
                errorObj.title = translate('Filesize limit reached');
                errorObj.description.push(translate(
                    'Processing of large files is only available for premium users. Upgrade your account to process large files.'
                ));
            }

            break;
        // warning:
        // this is actually never sent at the moment. this needs fixing in the uploader code. if the file
        // is too large for the current job then we also send a LIMIT_INPUT_TOO_LARGE
        case LIMIT_JOB_TOO_LARGE:
            if (isPremiumUser || isEducationalUser) {
                errorObj.title = translate('Filesize limit reached');
                errorObj.description.push(translate('You have reached the maximum file size for this tool.'));
                errorObj.showTryPremiumButton = false;
            } else {
                errorObj.title = translate('Filesize limit reached');
                errorObj.description.push(translate(
                    'Processing of large files is only available for premium users. Upgrade your account to process large files.'
                ));
            }

            break;
        case LIMIT_GENERIC_CONVERSION_OPTION_IS_PREMIUM:
            errorObj.title = translate('An account upgrade is needed');
            errorObj.description.push(translate(
                'For this feature, you require a premium account. Upgrade to get full access to all our tools.'
            ));

            break;
        case LIMIT_OCR_IS_PREMIUM:
            errorObj.title = translate('Not done using OCR yet?');
            errorObj.description.push(translate(
                'Processing files with OCR is only available for premium users. Upgrade your account to get full access to OCR.'
            ));

            break;
        case LIMIT_FEATURE_TOO_MANY_JOBS:
            errorObj.type = UPLOAD_BOX_ERROR_TYPE.COUNTDOWN;
            errorObj.canDismiss = false;

            errorObj.title = translate('Do you need to do more?');
            errorObj.description.push(translate(
                'To continue using this feature, you need to upgrade your account or come back in %time% to work on more files.'
            ));

            break;
        case LIMIT_GLOBAL_TOO_MANY_CONCURRENT_CONVERSIONS:
            errorObj.canDismiss = true;

            if (isPremiumUser || isEducationalUser) {
                errorObj.title = translate('You are processing too many tasks at the same time');
                errorObj.description.push(translate(
                    'To continue using this feature, you need to wait for your current tasks to finish.'
                ));
                errorObj.showTryPremiumButton = false;
            } else {
                errorObj.title = translate('You are processing too many tasks at the same time');
                errorObj.description.push(translate(
                    'To continue using this feature, you need to wait for your current tasks to finish.' +
                        translate('Upgrade to Premium to convert more files at once.')
                ));
                errorObj.showStartButton = false
            }
            break;
        case LIMIT_GLOBAL_TOO_MANY_JOBS:
            errorObj.type = UPLOAD_BOX_ERROR_TYPE.COUNTDOWN;
            errorObj.canDismiss = false;

            if (isPremiumUser || isEducationalUser) {
                errorObj.title = translate('Maximum number of tasks reached');
                errorObj.description.push(translate(
                    'You have reached the maximum amount of tasks you can do. Come back in %time% to work on more tasks.'
                ));
                errorObj.showTryPremiumButton = false;
            } else {
                errorObj.title = translate('Do you need to do more?');
                errorObj.description.push(translate(
                    'Upgrade to a premium account or come back in %time% to work on more files.'
                ));
            }

            break;
        case LIMIT_JOB_CONVERSIONS_BLOCKED:
            errorObj.canDismiss = false;
            errorObj.title = translate('Suspicious activity detected');
            errorObj.description.push(translate(
                'We have detected certain activity that may violate our terms. Please come back in'
            ) + ' ' + parseSecondsToReadable(limitData.ttl));
            errorObj.showTryPremiumButton = false;


            window.qgUploader.disable();

            break;

        case LIMIT_FEATURE_IS_PREMIUM:
            errorObj.canDismiss = false;
            errorObj.title = translate('You have discovered a premium feature');
            errorObj.description.push(translate(
                'This feature is only available for premium users. Upgrade your account to get full access to all our tools.'
            ));

            if (!testIsUndefined(global.pageConfig?.example_file)) {
                errorObj.description.push(translate(
                    'This feature is only available for premium users. Upgrade your account to get full access to all our tools.'
                ));
                errorObj.description.push(translate('Click on "Add example file" to test it for free.'));
            }

            window.qgUploader.disable();

            break;
        default:
            globalLogger.log('limit - unknown limit', JSON.stringify(limitData));

            errorObj.title = translate('Upgrade your account');
            errorObj.description.push(translate(
                'For this action, you require a premium account. Upgrade to get full access to all our tools.'
            ));
    }

    return errorObj;
}
